import { SafePromise } from '@benzinga/safe-await';
import { RestfulClient, Session } from '@benzinga/session';
import { HoldingsEnvironment } from './environment';
import { HoldingsIngress } from './ingress';

export class HoldingsRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(HoldingsEnvironment).url, session);
  }

  getHoldings = async (): SafePromise<HoldingsIngress[]> => {
    const url = this.session.getEnvironment(HoldingsEnvironment).url;
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'omit' });
  };
}
